import { useContext, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';

import { InteractiveComponentContext } from '../context';
import { DeviceTypeContext } from '../DeviceTypeContext.jsx';
import { useSpring } from 'react-spring';

const ViziaComponentAnimator = props => {
  const [interactiveComponent] = useContext(InteractiveComponentContext);
  const deviceType = useContext(DeviceTypeContext);

  const [spring, set] = useSpring(() => ({
    position: 'static'
  }));

  useLayoutEffect(() => {
    const animate = Boolean(
      interactiveComponent && interactiveComponent.id === props.id
    );
    if (animate) {
      set({
        from: { top: '100px', height: 'auto', maxHeight: 'auto' },
        to: [
          { opacity: 0 },
          {
            position: 'fixed',
            top: '100px', // TODO: This should not be hard coded. But can't get it working without atm
            zIndex: 10,
            opacity: 1,
            height: 'unset',
            maxHeight: 'unset',
            bottom: 0
          }
        ]
      });
    } else {
      set({
        to: [
          {
            top: '0px',
            position: 'static',
            zIndex: 'auto',
            height: 'auto',
            bottom: 'unset',
            maxHeight: 'auto',
            opacity: 1
          }
        ]
      });
    }
  });

  const childProps = { style: null, showCover: false, showHeader: true };

  if (deviceType.isMobile) {
    if (interactiveComponent && interactiveComponent.id === props.id) {
      childProps.style = spring;
      childProps.showCover = false;
      childProps.showHeader = false;
    } else {
      childProps.showCover = true;
      childProps.showHeader = true;
    }
  } else {
    childProps.showCover = false;
    childProps.showHeader = true;
  }

  return props.children(childProps);
};

ViziaComponentAnimator.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  children: PropTypes.func
};

export default ViziaComponentAnimator;
